export const environment = {
  production: false,
  baseUrl: '',
  useHash: false,
  hmr: false,
  showThemeToggle: true,
  translateText: false,
  collapsibleSidebar: true,
  showChatbot: false,
  useTimeout: false,
  idleInterval: 900,
  displaySidebar: true,
  build: 'Test',
  version: '4.0.0',
  theme: 'dark',
  publicApi: 'https://test-labcompliance.oregon.gov/api/public/',
  privateApi: 'https://test-labcompliance.oregon.gov/api/private/',
  authEntireSite: true, //will run authentication prior to loading the site, otherwise will only run auth when reqired by routes
  mfa: {
    required: false,
    timeout: 1440 //in minutes: 24 hrs = 1440
  },
  auth: {
    aad: {
      clientId: 'b3438b77-ae36-4435-85f9-1af2224d7478',
      scopes: ['api://b3438b77-ae36-4435-85f9-1af2224d7478/user.access'],
      groups: [],
      authority: 'https://login.microsoftonline.com/658e63e8-8d39-499c-8f48-13adc9452f4c/',
      redirectUri: 'https://test-labcompliance.oregon.gov',
    }
  },
  enableHttpsRedirect: true,
};

